export class Configuracao {}
